var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/youtube.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"408 -362 757 907\" class=\"c-social__youtube\" aria-labelledby=\"youtube-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"youtube-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-youtube"])), env.opts.autoescape);
output += "\n    </title>\n\t<path d=\"M408 290.6c0-31.6 1.8-78.9 5.3-142.1 2.3-31 13.4-56.3 33.3-75.9 19.9-19.6 45.3-30.3 76.3-32 58.5-2.9 146.5-4.4 264-4.4s205.6 1.5 264 4.4c31 1.8 56.4 12.4 76.3 32s31 44.9 33.3 75.9c2.9 52.6 4.4 100 4.4 142.1s-1.5 89.5-4.4 142.1c-2.3 31-13.4 56.3-33.3 75.9-19.9 19.6-45.3 30.3-76.3 32-58.5 2.9-146.5 4.4-264 4.4s-205.6-1.5-264-4.4c-31-1.8-56.4-12.4-76.3-32s-31-44.9-33.3-75.9c-3.5-63.1-5.3-110.5-5.3-142.1zm58.8-123.7h53.5v286H572v-286h53.5v-48.2H466.8v48.2zm57-528.9h52.6l33.3 133.3h3.5L644.8-362h52.6l-40.3 129.8c-13.4 42.7-20.2 64.6-20.2 65.8v138.6h-51.8v-132.5c-1.2-8.2-2.8-15.6-4.8-22.4-2-6.7-4.7-14.5-7.9-23.2s-5.7-16.1-7.5-21.9L523.8-362zm101.7 776.3c0 28.1 10.5 42.1 31.6 42.1 18.7 0 36.5-10.2 53.5-30.7v27.2h45.6V206.4h-45.6v187.7c-12.3 12.3-21.3 18.4-27.2 18.4-8.2 0-12.3-5.6-12.3-16.7V206.4h-45.6v207.9zm69.3-504.4v-128.1c0-19.9 6.4-35.2 19.3-46.1 12.9-10.8 29.2-16.2 49.1-16.2 19.3 0 34.9 5.8 46.9 17.5s18 27.2 18 46.5v127.2c0 21.1-5.8 37.6-17.5 49.6s-28.1 18-49.1 18c-20.5 0-36.7-6.3-48.7-18.9s-18-29-18-49.5zm47.4 6.2c0 13.4 6.4 20.2 19.3 20.2 13.5 0 20.2-7.3 20.2-21.9v-134.2c0-5.3-2-9.6-6.1-13.2-4.1-3.5-8.8-5.3-14-5.3-5.3 0-9.8 1.6-13.6 4.8-3.8 3.2-5.7 7.5-5.7 12.7v136.9zM801 452.9h46.5v-18.4c11.7 14.6 26.3 21.9 43.9 21.9 27.5 0 41.2-18.1 41.2-54.4V265.2c0-41.5-14.9-62.3-44.7-62.3-14.6 0-28.1 7.9-40.3 23.7V118.7H801v334.2zm46.5-46.5V252c6.4-6.4 12.9-9.6 19.3-9.6 12.9 0 19.3 8.2 19.3 24.6v129.8c0 14-5.6 21.1-16.7 21.1-8.2-.1-15.5-3.9-21.9-11.5zm20.1-472.8v-207.9h45.6v188.6c0 11.1 4.1 16.7 12.3 16.7 7.6 0 16.7-6.1 27.2-18.4v-186.8h45.6v246.5h-45.6V-55c-17 20.5-34.8 30.7-53.5 30.7-21 0-31.6-14-31.6-42.1zm100 450c0 22.2 5.6 40.5 16.7 54.8 11.1 14.3 27.8 21.5 50 21.5 45.6 0 68.4-25.4 68.4-76.3v-18.4h-47.4c0 1.2.1 5.1.4 11.8.3 6.7.1 11.5-.4 14.5-.6 2.9-1.3 6.9-2.2 11.8-.9 5-2.8 8.5-5.7 10.5-2.9 2-7 3.1-12.3 3.1-13.5 0-20.2-11.7-20.2-35.1v-46.5h87.7v-63.2c0-22.2-5.4-39.8-16.2-52.6-10.8-12.9-27.3-19.3-49.6-19.3-21.1 0-37.9 6.7-50.4 20.2s-18.9 30.7-18.9 51.8v111.4zm47.4-86.8v-26.3c0-18.1 6.7-27.2 20.2-27.2 13.4 0 20.2 9.1 20.2 27.2v26.3H1015z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/youtube.j2"] , dependencies)